import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { placeholderMembersApi } from 'src/Services/API';
import { PendingPlaceholderMatchDto } from 'src/Services/API/generated';
import { ApiError } from 'src/types/api-error.types';

const useFetchPendingPlaceholderMatches = (enabled = true) => {
  return useQuery<PendingPlaceholderMatchDto[], AxiosError<ApiError>>({
    queryKey: ['fetch-pending-placeholder-matches'],
    queryFn: async () =>
      (await placeholderMembersApi.placeholderMembersControllerFindPendingMatches()).data,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
};

export default useFetchPendingPlaceholderMatches;
